import { createApp } from 'vue';
import App from './App.vue';
import { createI18n } from 'vue-i18n';
import en from './translations/en.json';
import zh from './translations/zh.json';
import '@/css/styles.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; // Bootstrap JS

const i18n = createI18n({
  locale: 'en', // default locale
  messages: { en, zh }
});

const fontAwesomeCdn = document.createElement('link');
fontAwesomeCdn.rel = 'stylesheet';
fontAwesomeCdn.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css';
document.head.appendChild(fontAwesomeCdn);

const app = createApp(App);
app.use(i18n);
app.mount('#app');
